import Script from 'next/script'

export const renderSnippet = (nonce: string, gaTrackingId?: string) => (
  <>
    <Script
      id="gta-first"
      nonce={nonce}
      src={`https://www.googletagmanager.com/gtag/js?id=${gaTrackingId}&l=dataLayerGTag`}
      strategy="afterInteractive"
    />
    <Script
      dangerouslySetInnerHTML={{
        __html: `window.dataLayerGTag = window.dataLayerGTag || [];
                  function gtag(){dataLayerGTag.push(arguments);}
                  gtag('js', new Date());
                  gtag('config', '${gaTrackingId}');
                  `,
      }}
      id="gta-second"
      nonce={nonce}
      strategy="afterInteractive"
    />
  </>
)
